import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin-settings")({
  component: Outlet,
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("AdminSettings"),
    }
  },
})
